import React from 'react';
import {
  Edit,

  TextInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  BooleanInput,
  required,
  email,
  TabbedForm,
  FormTab,
} from 'react-admin';

export const UserEdit = () => (
  <Edit>
    <TabbedForm>
      <FormTab label="Основная информация">
        <TextInput source="name" validate={[required()]} label="Имя" />
        <TextInput source="email" validate={[required(), email()]} label="Email" />
        <NumberInput source="age" label="Возраст" />
        <TextInput source="profession" label="Профессия" />
        <TextInput source="company" label="Компания" />
        <TextInput source="location" label="Местоположение" />
        <TextInput source="phone" label="Телефон" />
        <TextInput source="bio" multiline rows={3} label="Био" />
        <TextInput source="avatarUrl" label="URL аватара" />
      </FormTab>

      <FormTab label="Навыки">
        <ArrayInput source="skills" label="Навыки">
          <SimpleFormIterator>
            <TextInput source="" label="Навык" />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      <FormTab label="Кошельки">
        <TextInput source="walletAddress" label="ETH кошелек" />
        <NumberInput source="walletChainId" label="Chain ID" />
        <TextInput source="tonWalletAddress" label="TON кошелек" />
      </FormTab>

      <FormTab label="Telegram">
        <BooleanInput source="telegramLinked" label="Telegram подключен" />
        <TextInput source="telegramId" label="Telegram ID" />
        <TextInput source="telegramUsername" label="Username" />
        <TextInput source="telegramFirstName" label="Имя" />
        <TextInput source="telegramLastName" label="Фамилия" />
        <TextInput source="telegramPhotoUrl" label="URL фото" />
        <TextInput source="telegramLanguageCode" label="Язык" />
        <BooleanInput source="telegramIsPremium" label="Premium" />
      </FormTab>

      <FormTab label="Доставка">
        <TextInput source="shippingCountry" label="Страна" />
        <TextInput source="shippingCity" label="Город" />
        <TextInput source="shippingAddress" label="Адрес" />
        <TextInput source="shippingZipCode" label="Индекс" />
        <TextInput source="shippingNotes" multiline rows={2} label="Примечания" />
      </FormTab>

      <FormTab label="Безопасность">
        <BooleanInput source="twoFactorEnabled" label="2FA включен" />
      </FormTab>
    </TabbedForm>
  </Edit>
);
